import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { useState, useEffect } from "react";
export var useUserProfile = function() {
    var ref = useState(false), isUserRegistered = ref[0], setIsUserRegistered = ref[1];
    var ref1 = useState(true), isProfileLoading = ref1[0], setIsLoading = ref1[1];
    var getUserProfile = function() {
        var _ref = _async_to_generator(function() {
            var res, data, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            fetch("/api/v1/profile")
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            4,
                            res.json()
                        ];
                    case 2:
                        data = _state.sent();
                        if (data.error || !data.state) {
                            setIsUserRegistered(false);
                        }
                        if (data.state === "REGISTERED") {
                            setIsUserRegistered(true);
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        setIsUserRegistered(false);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function getUserProfile() {
            return _ref.apply(this, arguments);
        };
    }();
    useEffect(function() {
        getUserProfile();
    }, []);
    return {
        isUserRegistered: isUserRegistered,
        isProfileLoading: isProfileLoading
    };
};
